<template>
    <div class="row justify-content-center" @keyup.enter="validate">
        <div class="col-lg-9">
            <div class="login wow zoomIn" data-wow-duration="1.5s">
                <h1 class="login__title">Login</h1>
                <div class="row justify-content-center">
                    <div class="col-md-7">
                        <div class="form">
                            <ValidationObserver ref="form">

                                <ValidationProvider
                                    class="form-group"
                                    name="Email"
                                    v-slot="{ errors }"
                                    rules="required|email"
                                >
                                    <span class="form-label">Email Address*</span>
                                    <input
                                        type="email"
                                        class="form-control"
                                        v-model="form.email"
                                    >
                                    <FormError :error="errors[0]" name="Email"></FormError>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="form-group"
                                    name="Password"
                                    v-slot="{ errors }"
                                    rules="required"
                                >
                                    <span class="form-label">Password*</span>
                                    <input
                                        type="password"
                                        class="form-control"
                                        v-model="form.password"
                                    >
                                    <FormError :error="errors[0]" name="Password"></FormError>
                                </ValidationProvider>

                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="form-check">
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input-checkbox"
                                                    v-model="form.remember"
                                                >
                                                <span class="form-check-label color_primary">Remember Me</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group text-right">
                                            <a href="/user/forgot-password" class="login___forgot">Forgot Password?</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button
                                        type="submit"
                                        class="btn btn_golden w-100"
                                        @click="validate"
                                    >
                                        <span>Login</span>
                                    </button>
                                </div>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormError from "../Common/FormError.vue";
import RegisterAndLoginServices from "../../services/RegisterAndLoginServices";

export default {
    name: 'LoginForm',
    components: {FormError},
    data() {
        return {
            form: {
                email: null,
                password: null,
                remember: null,
            }
        }
    },
    methods: {
       async validate() {
           this.$showLoadingMessage()
           const valid = await this.$refs.form.validate();

           if (!valid) {
               this.$showValidationErrorMessage();
               return;
           }
           await this.login()
        },
        async login() {
           try {
               const response = await RegisterAndLoginServices.userLogin(this.form)

               this.$showSuccessMessage()
               if (response) {
                   window.location.href = response.data.redirect
               } else {
                   window.location.href = '/artist/profile'
               }
           } catch (error) {
               console.log(error)
               this.$showErrorMessage(`${error.response.data.error}`)
           }
        }
    }
}

</script>

<style>

</style>
